import React, { useState, useEffect } from 'react';
import './choose1.css'; // Importer les styles pour Choose1
// import { FaCircleCheck, FaCircle } from "react-icons/fa6";
import medic from '../../assets/images/Medic.png';
import success from '../../assets/images/success.png';
import paypal from '../../assets/images/paypal.png';
import mtn from '../../assets/images/mtn.png';
import bank from '../../assets/images/bank.png';
// import { FaFile } from "react-icons/fa6";
import { motion } from 'framer-motion';
import api from '../../service/caller'; // Axios instance configurée

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logomedtinz from '../../assets/images/MedTinz.png';
import imageOrangeTopLeft from '../../assets/images/Medic symbol circle.png';
import imageOrangeBottomLeft from '../../assets/images/Checklist.png';
import Pil from '../../assets/images/Pil.png';
import Dna from '../../assets/images/DNA.png';

const Choose1 = ({ planId }) => {
  const [subscriptionDetails, setSubscriptionDetails] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [paymentSuccessful, setPaymentSuccessful] = useState(false);
  const [paymentSectionVisible, setPaymentSectionVisible] = useState(true); // Section de paiement visible
  const [features, setFeatures] = useState([]); // Etat pour stocker les fonctionnalités

  useEffect(() => {
    const fetchPlan = async () => {
      try {
        const subscriptionResponse = await api.get(`/api/subscriptions/${planId}`);

        setSubscriptionDetails(subscriptionResponse.data);
      } catch (error) {
        console.error('Error fetching subscription plan:', error);
      }
    };

    const fetchFeatures = async () => {
      try {
        const { data } = await api.get('/api/getallfeatures');
        setFeatures(data); // Stocker les fonctionnalités dans l'état
      } catch (error) {
        console.error('Error fetching features:', error);
      }
    };

    fetchPlan();
    fetchFeatures();
  }, [planId]);

  const handleSelectPaymentMethod = (e) => {
    const method = e.target.value;
    setPaymentMethod(method);
  };

  const handlePhoneNumberChange = (e) => {
    setPhoneNumber(e.target.value);
  };

  // handleMomoPaymentConfirmation
  const handlePaymentConfirmation = async (e) => {
    e.preventDefault();

    // Préparation des données de paiement
    const paymentData = {
      item_name: 'Subscription Payment',
      price: subscriptionDetails?.price, // Récupérer le prix de l'abonnement
      currency: 'USD', // Monnaie en USD
      paymentReason: 'Subcription Nomal for hospital', // Monnaie en USD
      motifId: 'Subcription Personalized', // Monnaie en USD
    };

    try {
      // Soumettre les données au backend pour générer le lien de redirection PayPal
      const paymentResponse = await api.post(`/payment/pay`, paymentData);

      // Si PayPal a généré une URL d'approbation
      if (paymentResponse.data.approval_url) {
        // Ouvrir l'URL d'approbation dans un nouvel onglet
        window.open(paymentResponse.data.approval_url, '_blank');
      } else {
        console.error('Erreur : approval_url non trouvé dans la réponse.');
      }
    } catch (error) {
      console.error('Erreur lors du paiement:', error);
    }
  };

  const handleMomoPaymentConfirmation = async (e) => {
    e.preventDefault();

    // Préparation des données de paiement
    const paymentData = {
      item_name: 'Subscription Payment',
      amount: subscriptionDetails?.price, // Récupérer le prix de l'abonnement
      currency: 'USD', // Monnaie en USD

      // amount: subscriptionDetails?.price,
      phoneNumber: phoneNumber || '',
      payerMessage: 'Paiement de service',

      paymentReason: 'Subcription Nomal for hospital', // Monnaie en USD
      motifId: 'Subcription Normal', // Monnaie en USD
    };

    try {
      // Soumettre les données au backend pour générer le lien de redirection PayPal
      const paymentResponse = await api.post(`/payment/paymentmomo/initiate`, paymentData);

      // Si PayPal a généré une URL d'approbation
      if (paymentResponse?.status == 200) {
        // Ouvrir l'URL d'approbation dans un nouvel onglet
        toast.success("Payment successful!");
        setTimeout(() => {
          window.location.href = '/hospitaladmin/dashboard';
        }, 2000);  // 2000 ms = 2 secondes

      } else {
        toast.error("Payment failed!");
      }
    } catch (error) {
      console.error('Erreur lors du paiement:', error);
      toast.error(`Payment failed: ${error?.message}. Please try again.`);
    }
  };

  return (
    <div className="choose1-container">
      <ToastContainer />
      <motion.div
        initial={{ x: '-100vw' }}
        animate={{ x: 0 }}
        exit={{ x: '100vw' }}
        transition={{ duration: 0.5 }}
      >
        <div className='microbes position-relative'>
          <section className='py-5 position-relative' style={{ background: '#0056B3' }}>
            <div className='container mt-5'>
              <div className='row text-center'>
                <div className='col-lg-3 mb-3'>
                  <div className='mt-2'>
                    <img src={logomedtinz} alt="Bottom left orange" className="logomedtinz" />
                  </div>
                </div>
                <div className='col-lg-6 mb-3'>
                  <h2 className='text-white text-center' style={{ fontSize: '45px', fontFamily: 'Inter,sans-serif', fontWeight: '600' }}>
                    Choose the right  medical subscription for you
                  </h2>
                </div>
                <div className='col-lg-3'></div>
              </div>
              <div className='d-flex justify-content-center'>
                <div style={{ width: '66%' }}>
                  <p className='text-center text-white'>Choose the plan that’s right for your business. Whether you’re just getting started with email marketing or well down the path to personalization, we’re got you covered</p>
                </div>
              </div>
            </div>
            <div style={{ position: 'absolute', right: '0', top: '0' }}>
              <img src={imageOrangeTopLeft} />

            </div>
            <div style={{ position: 'absolute', left: '0', bottom: '-5rem' }}>
              <img src={imageOrangeBottomLeft} />
            </div>
          </section>

          <div className='container mt-4'>
            <div className='row'>
              {paymentSectionVisible && (
                <>
                  <div className='col-lg-6 mt-4'>
                    <h1 className='pingo mt-5 mt-md-1'>Payment</h1>
                    <hr className='hin'></hr>
                    <p className='mt-3 shilo'>Pay With:</p>
                    <div className="loli">
                      <div className='nina'>
                        <div>
                          <input
                            type="radio"
                            id="paypal"
                            name="paymentMethod"
                            value="paypal"
                            checked={paymentMethod === 'paypal'}
                            onChange={handleSelectPaymentMethod}
                          />
                          <label htmlFor="paypal">
                            <img src={paypal} alt="PayPal" className="paypal mb-3 mt-2" />
                          </label>
                        </div>
                        <div>
                          <input
                            type="radio"
                            id="mtnmomo"
                            name="paymentMethod"
                            value="mtnmomo"
                            checked={paymentMethod === 'mtnmomo'}
                            onChange={handleSelectPaymentMethod}
                          />
                          <label htmlFor="mtnmomo">
                            <img src={mtn} alt="Bank Transfer" className="paypal mb-3 mt-2" />
                          </label>
                        </div>
                        <div>
                          <input
                            type="radio"
                            id="card"
                            name="paymentMethod"
                            value="card"
                            checked={paymentMethod === 'card'}
                            onChange={handleSelectPaymentMethod}
                          />
                          <label htmlFor="card">
                            <img src={bank} alt="Credit Card" className="paypal mb-3 mt-3 px-2" />
                          </label>
                        </div>
                      </div>
                      {paymentMethod === 'paypal' && (
                        <div className="payment-form">
                          <button
                            onClick={handlePaymentConfirmation}
                            className='gigo mb-3'
                          >
                            <b>Confirm Payment</b>
                          </button>
                        </div>
                      )}

                      {/* Si la méthode de paiement est MTN MoMo, afficher l'input pour le numéro de téléphone */}
                      {paymentMethod === 'mtnmomo' && (
                        <div>
                          <label htmlFor="phoneNumber">Numéro de téléphone:</label>
                          <input
                            type="tel"
                            id="phoneNumber"
                            className='form-control my-2 py-3'
                            value={phoneNumber}
                            onChange={handlePhoneNumberChange}
                            placeholder="Entrer votre numéro de téléphone"
                          />
                        </div>
                      )}

                      {paymentMethod === 'mtnmomo' && (
                        <div className="payment-form">
                          <button
                            onClick={handleMomoPaymentConfirmation}
                            className='gigo mb-3'
                          >
                            <b>Confirm Payment</b>
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className='col-lg-6 mt-5 mb-2'>
                    <div className='yaourt'>
                      <h6 className='tibus'>{subscriptionDetails?.name}</h6>
                      <h1 className='tern'>{subscriptionDetails?.price} fcfa <span className='ray'>
                        per {subscriptionDetails?.duration}
                        {subscriptionDetails?.duration < 12 ? ` months` : ' year'}
                      </span></h1>
                      {/* Bloc des features */}
                      <div className="container mt-4">
                        <ul className="list-group">
                          {features.map((feature, index) => {
                            const featureValue = subscriptionDetails?.features?.[index];
                            return (
                              <li key={index} className="list-group-item d-flex" style={{ border: "none" }}>
                                <span>
                                  {featureValue === 'true' ? (
                                    <span style={{ color: "green", fontWeight: "bold" }}>✅</span>
                                  ) : featureValue === 'false' ? (
                                    <span style={{ color: "red", fontWeight: "bold" }}>❌</span>
                                  ) : featureValue !== undefined && featureValue !== null ? (
                                    // Si la valeur est autre que 'true' ou 'false', on affiche la coche verte
                                    <span style={{ color: "green", fontWeight: "bold" }}>✅</span>
                                  ) : (
                                    <span style={{ color: "red", fontWeight: "bold" }}>❌</span>
                                  )}
                                </span>
                                {/* Affichage du nom et de la valeur de la feature */}
                                {featureValue !== undefined && featureValue !== null && featureValue !== 'true' && featureValue !== 'false' ? (
                                  <span className='mx-2'>{feature.name}: { }</span>
                                ) : (
                                  <span className='mx-2'>{feature.name}</span>
                                )}
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {paymentSuccessful && !paymentSectionVisible && (
                <div className="row">
                  <div className='col-lg-6 mt-3'>
                    <div className="payment-success">
                      <h1 className='joy'>Successful payment</h1>
                      <p>You have successfully subscribed to the standard plan.</p>
                      <button className='troy'>Continue configuration</button>
                    </div>
                  </div>
                  <div className='col-lg-6'>
                    <div className='yaourt mt-5'>
                      <h3>Plan Name: {subscriptionDetails?.name}</h3>
                      <h1>{subscriptionDetails?.price} fcfa <span className='ray'>
                        per {subscriptionDetails?.duration}
                        {subscriptionDetails?.duration < 12 ? ` months` : ' year'}</span></h1>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className='container'>
            <div><img src={Pil} className='img-fluid' /></div>
            <div className='d-none d-lg-block'><img src={Dna} className='img-fluid pil2' /></div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default Choose1;
